// Initialize global logger FIRST - this must happen before ANY other imports
import './logger-init';

// Now import everything else - decorators will now use monkey patched console
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { Log } from './app/services/logger.service';

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => Log.e('BOOTSTRAP', 'Failed to bootstrap Angular application', err));
